import { render, staticRenderFns } from "./ArtificialPaperOperate.vue?vue&type=template&id=2668ec47&scoped=true"
import script from "./ArtificialPaperOperate.vue?vue&type=script&lang=js"
export * from "./ArtificialPaperOperate.vue?vue&type=script&lang=js"
import style0 from "./ArtificialPaperOperate.vue?vue&type=style&index=0&id=2668ec47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668ec47",
  null
  
)

export default component.exports